// extracted by mini-css-extract-plugin
module.exports = {"choiceContainer":"style__choiceContainer__4FHwf","choice":"style__choice__cJLml","icon":"style__icon__QzsIP","linkText":"style__linkText__oQqHM"};